const axios = require('axios')

const useBatchService = () => {
    const batchRequest = async (requests, maxBatchSize = 5) => {
        try {
            const batchRequests = requests.map(request =>
                (typeof request === 'object' && request.url ? axios(request) : axios.get(request)).catch(error => {
                    return null
                })
            )

            const responses = await Promise.all(batchRequests)
            return responses.map(response => {
                if (!response) return { data: null, error: 'Request failed' }
                return { data: response.data, error: null }
            })
        } catch (error) {
            console.error('Error in batch processing:', error)
            throw error
        }
    }

    const batchRequestWithRetry = async (requests, maxRetries = 3) => {
        let retries = 0
        let results = []

        while (retries < maxRetries) {
            try {
                results = await batchRequest(requests)

                // Check if any requests failed
                const failedRequests = results.filter(result => result.error)
                if (failedRequests.length === 0) {
                    return results
                }

                // Update requests array to only include failed requests
                requests = requests.filter((_, index) => results[index].error)
                retries++

                if (retries < maxRetries) {
                    await new Promise(resolve => setTimeout(resolve, 1000 * retries))
                }
            } catch (error) {
                console.error(`Batch request retry ${retries + 1} failed:`, error)
                retries++
                if (retries === maxRetries) throw error
            }
        }

        return results
    }

    return {
        batchRequest,
        batchRequestWithRetry
    }
}

module.exports = useBatchService
